import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { css } from 'aphrodite/no-important';
import { styles } from './FeedbackPanelStyles';
import { Field, reduxForm } from 'redux-form';
import SuccessMessage from '../components/SuccessMessage';

import { feedbackActions } from '../_actions';

class FeedbackPanel extends Component {
  submit = (values, dispatch, props) => {
    this.props.dispatch(feedbackActions.submitFeedback(props.user === 'dependant' ? props.authentication.user.dependant_user_id : props.authentication.user.user_id, values));

  };

  render() {
    const { handleSubmit, submitSucceeded } = this.props;

    return (
      <Fragment>
        {submitSucceeded && <SuccessMessage message="Thanks for your feedback" />}
        <h3 className={css(styles.feedbackTitle)}>Your feedback</h3>
        <form onSubmit={handleSubmit(this.submit)}>
          <Field
            name="feedback"
            className={css(styles.input)}
            component="textarea"
            placeholder="I'd like to say..."
          />
          <button type='submit' className={css(styles.buttonGreen)}>Send Feedback</button>
        </form>
      </Fragment>
    );
  }
}

function mapStateToProps(state) {
  const { alert } = state;
  const feedback = state.feedback;
  const authentication = state.authentication;
  return {
    alert,
    feedback,
    authentication
  };
}

export default connect(mapStateToProps)(
  reduxForm({
    form: 'feedback', // <------ same form name
    destroyOnUnmount: false, // <------ preserve form data
  })(FeedbackPanel)
)
